// TODO remove this class entirely for something that makes plurals, or a time/date lib
export class Unit {
  private readonly singular: string;

  private readonly plural: string;

  public readonly unit: string;

  private readonly unitMap: {
    [key: string]: { singular: string; plural: string };
  } = {
    month: {
      singular: "month",
      plural: "months",
    },
    months: {
      singular: "month",
      plural: "months",
    },
    day: {
      singular: "day",
      plural: "days",
    },
    days: {
      singular: "day",
      plural: "days",
    },
    week: {
      singular: "week",
      plural: "weeks",
    },
    weeks: {
      singular: "week",
      plural: "weeks",
    },
  };

  constructor(unit: string) {
    this.unit = unit;
    const { singular, plural } =
      unit.toLowerCase() in this.unitMap
        ? this.unitMap[unit.toLowerCase()]
        : { singular: unit, plural: unit };
    this.singular = singular;
    this.plural = plural;
  }

  public getUnitForValue(value: number): string {
    return value === 1 ? this.singular : this.plural;
  }
}
